import { useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { Typography } from '../../../../stories/atoms';
import { muiTheme } from '../../../../theme';
import { homeTranslations } from '../../../../translations';
import { InfoTooltipIcon } from '../infoTooltipIcon/InfoTooltipIcon';
import {
  LayoutChart,
  LayoutContent,
  LayoutLabel,
  LayoutSection,
  LayoutWrapper,
} from './WidgetMobileLayout.styles';

type MetricItem = {
  label: string;
  content: string | JSX.Element;
  isLoading?: boolean;
  isError?: boolean;
  tooltipText?: string;
};

type WidgetMobileLayoutProps = {
  metricItems: MetricItem[];
  topContent?: JSX.Element;
  enableFlex?: boolean;
  renderChart?: () => JSX.Element;
};

export const WidgetMobileLayout: FC<WidgetMobileLayoutProps> = ({
  metricItems,
  topContent,
  enableFlex,
  renderChart,
}) => {
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('tabletPortrait'));
  const { common: commonTranslations } = homeTranslations;

  return (
    <LayoutWrapper data-testid="layout-wrapper">
      {topContent && topContent}

      <LayoutContent data-testid="layout-content">
        {metricItems.map((item, index) => {
          const { label, content, isLoading = false, isError = false, tooltipText } = item;
          return (
            <LayoutSection key={index} enableFlex={enableFlex}>
              <LayoutLabel>
                <Typography color={isMobile ? 'primary' : 'textGray'}>{label}</Typography>
                <InfoTooltipIcon tooltipText={tooltipText} testId={`mobile-label-tooltip-${index}`} />
              </LayoutLabel>

              {isLoading && <Typography>{commonTranslations.loading.defaultValue} ...</Typography>}
              {!isLoading && isError && (
                <Typography color="error">{commonTranslations.error.defaultValue}</Typography>
              )}
              {!isLoading && !isError && (
                <>
                  {typeof content === 'string' && <Typography>{content}</Typography>}

                  {typeof content !== 'string' && content}
                </>
              )}
            </LayoutSection>
          );
        })}
      </LayoutContent>
      {renderChart && <LayoutChart data-testid="layout-chart"> {renderChart()}</LayoutChart>}
    </LayoutWrapper>
  );
};
